// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

import store from './store';

Vue.config.productionTip = false;

import 'tachyons/css/tachyons.min.css';
import 'tachyons-flexbox/css/tachyons-flexbox.min.css';


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store,
});



// WEBPACK FOOTER //
// ./admin/src/main.js